import React from 'react';
import {useIntl} from 'react-intl';
import {Modal, Text} from '@forecast-it/design-system';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';
import {ModalProps} from '../../../../shared/components/modals/types';

export type DisableTemplateDeliverablesModalPayload = {onConfirm: () => void};

export const showDisableTemplateDeliverablesModal = (props: DisableTemplateDeliverablesModalPayload): void => {
	showModal({type: MODAL_TYPE.DISABLE_TEMPLATE_DELIVERABLES, ...props});
};

/** Confirms turning a template's deliverables off: every line moves to its phase, and no line is deleted. */
export const DisableTemplateDeliverablesModal = ({
	onConfirm,
	closeModal,
}: ModalProps<DisableTemplateDeliverablesModalPayload>): JSX.Element => {
	const {formatMessage} = useIntl();
	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>{formatMessage({id: 'baseline_templates.deliverables.disable.title'})}</Modal.Title>
			<Modal.Content>
				<Text>{formatMessage({id: 'baseline_templates.deliverables.disable.description'})}</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton
					onPress={() => {
						onConfirm();
						closeModal();
					}}
					dataCy="disable-template-deliverables-confirm"
				>
					{formatMessage({id: 'baseline_templates.deliverables.disable.confirm'})}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal} dataCy="disable-template-deliverables-cancel">
					{formatMessage({id: 'common.cancel'})}
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};
